import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom';

import './styles/colors_and_type.css';
import './styles/global.css';

import { PennyRoot } from '@/lib/penny';
import { App } from './App';

const container = document.getElementById('app');
const root = createRoot(container!);
root.render(
  <StrictMode>
    <PennyRoot>
      <BrowserRouter>
        <App />
      </BrowserRouter>
    </PennyRoot>
  </StrictMode>
);
